import {getUrlParameter, replaceUrlParam} from '@js/helpers/location';

export default function initAppliedFiltersListeners() {
    $('body')
        .on('click', '.remove-all-applied-filters', () => {
            window.location.search = '';
        })
        .on('click', '.remove-applied-filter', function () {
            const isMultiple = $(this).data('multiple') === true;
            const filterName = $(this).data('filter');
            let replacementValue;
            if (isMultiple) {
                const multipleFilterValue = $(this).data('multiple-value');
                const urlParamValues = getUrlParameter(filterName);
                replacementValue = urlParamValues.filter((item) => item != multipleFilterValue);
            } else {
                replacementValue = '';
            }
            window.location.search = replaceUrlParam(filterName, replacementValue);
        });
}
